import doMetric from '../tracking/bigQueryMetricRecorder';
import Track from '../utils/tracking';

/**
 * Extracts order summary data and logs metrics for basket operations
 * @param {Object} orderSummary - The order summary object
 * @param {string} eventType - The event type for logging ('basketEditBefore' or 'basketEditAfter')
 * @param {number} productId - The product ID being added/removed
 * @param {boolean} isAddToBasket - Whether this is an add or remove operation
 * @returns {Object} The extracted order summary data
 */
export const extractOrderSummaryDataAndLog = (orderSummary, eventType, productId, isAddToBasket) => {
  try {
    const extractedData = extractOrderSummaryData(orderSummary);
    
    doMetric(
      eventType,
      [
        {name: 'basketItemCount', value: extractedData.basketItemCount},
        {name: 'productIds', value: JSON.stringify(extractedData.productIds)},
        {name: 'itemTotalPrice', value: extractedData.itemTotalPrice},
        {name: 'orderTotal', value: extractedData.orderTotal},
        {name: 'deliveryPrice', value: extractedData.deliveryPrice},
        {name: 'discountedDeliveryPrice', value: extractedData.discountedDeliveryPrice},
        {name: 'creditUsed', value: extractedData.creditUsed},
        {name: 'appliedGiftcardTotal', value: extractedData.appliedGiftcardTotal},
        {name: 'productId', value: productId},
        {name: 'isAddToBasket', value: isAddToBasket},
      ], [], 'impression'
    );

    return extractedData;
  } catch (error) {
    Track.error('Failed to extract and log order summary data:', error);
    return null;
  }
};

/**
 * Extracts order summary data for logging purposes
 * @param {Object} orderSummary - The order summary object
 * @returns {Object} The extracted order summary data
 */
export const extractOrderSummaryData = (orderSummary) => {
  try {
    if (!orderSummary) {
      return null;
    }

    const basketItems = orderSummary.basketItems || [];
    const basketItemCount = basketItems.length;
    const productIds = basketItems.map(item => item.productId).filter(id => id !== undefined);
    const itemTotalPrice = orderSummary.itemTotalPrice?.value;
    const orderTotal = orderSummary.orderTotal?.value;
    const deliveryPrice = orderSummary.deliveryPrice?.value;
    const discountedDeliveryPrice = orderSummary.discountedDeliveryPrice?.value;
    const creditUsed = orderSummary.credit?.used?.value;
    const appliedGiftcardTotal = orderSummary.appliedGiftCardTotal?.value;

    return {
      basketItemCount,
      productIds,
      itemTotalPrice,
      orderTotal,
      deliveryPrice,
      discountedDeliveryPrice,
      creditUsed,
      appliedGiftcardTotal,
    };
  } catch (error) {
    Track.error('Failed to extract order summary data:', error);
    return null;
  }
};

export default extractOrderSummaryDataAndLog;